import React, { Component } from 'react';
import '../../../index.css';
import Side from './sectionSide';

class SectionController extends Component{
  constructor(props) {
    super(props);
    this.state = {
      column3: 'col-3',
      column5: 'col-3'
    }
  }
  render(){
    const imageTemplate = `
      <div class="badge ${this.props.content.badgeBackground}">${this.props.content.badgeTitle}</div>
    `;
    const descriptionTemplate = `
        <h2>${this.props.content.title}</h2>
        <p>${this.props.content.description}</p>
      `;
    // Content
    let contentLeft = imageTemplate;
    let contentRight = descriptionTemplate;
    // Default Position
    let columnLeft = this.state.column3;
    let columnRight = this.state.column5;
    // Invert Column Position
    if(this.props.content.imagePosition === "right"){
      contentLeft = descriptionTemplate;
      contentRight = imageTemplate;
      columnLeft = this.state.column5;
      columnRight = this.state.column3;
    }
    return(
      <section className={`description ${this.props.content.colorBackground} ${this.props.content.imagePosition}`}>
        <div className="row">
          <div className={columnLeft}>
            <Side content={contentLeft} />
          </div>
          <div className={columnRight}>
            <Side content={contentRight} />
          </div>
        </div>
      </section>
    )
  }
}

export default SectionController;



// WEBPACK FOOTER //
// ./src/components/homepage/views/section.js